import { createFileRoute } from '@tanstack/react-router';
import { PurchasePage } from '@/components/purchases/purchase-page';

export const Route = createFileRoute('/expenses/expenses/$documentId')({ component: View });

function View() {
  const { documentId } = Route.useParams();
  return <PurchasePage kind="expense" id={documentId} />;
}
